import { Card } from "@jhool-io/fe-components";

export default function NoteFormInfoBox() {
    return (
        <Card classNames="flex flex-col w-full text-caption">
            <p className="mb-px font-semibold text-base">Instructions</p>
            <ol className="list-inside font-regular">
                <li className="list-decimal list-inside">
                    The fields marked with an asterisk (
                    <span className="text-danger">*</span>) are required before
                    you can submit your notes.
                </li>
                <li className="list-decimal list-inside">
                    Before you can submit your session notes, they must be
                    signed. You have the option to save your notes as a draft
                    before making a submission.
                </li>
            </ol>
        </Card>
    );
}
